import { render } from "./MailModalBody.vue?vue&type=template&id=48696568&scoped=true"
import script from "./MailModalBody.vue?vue&type=script&lang=js"
export * from "./MailModalBody.vue?vue&type=script&lang=js"

import "./MailModalBody.vue?vue&type=style&index=0&id=48696568&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3809301774/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48696568"]])

export default __exports__